<template>
	<div>
		<div class="notification-shape shape-progress" id="notification-shape" style="display: none">
			<div class="ns-box ns-other ns-effect-loadingcircle ns-type-notice ns-show"><div class="ns-box-inner"><span class="ico"><i class="os-icon os-icon-mail-18"></i></span><p>{{ msg }}</p></div><span class="ns-close"></span></div>
			<svg width="70px" height="70px"><path d="m35,2.5c17.955803,0 32.5,14.544199 32.5,32.5c0,17.955803 -14.544197,32.5 -32.5,32.5c-17.955803,0 -32.5,-14.544197 -32.5,-32.5c0,-17.955801 14.544197,-32.5 32.5,-32.5z"></path></svg>
		</div>
	</div>
</template>

<script>
    export default {
        name: 'shapeNotify',
        data () {
            return {
                msg: 'Oturum açıldı.'
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ico {
	font-size: 26px;
	float: left;
	margin: 0 10px 2px 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/ui/notify/shapeNotify.vue